export default {
    "Not linked to a wish": "Niet gekoppeld aan een wens",
    "Card number": "Kaartnummer",
    'Select a wish': 'Kies een wens',
    'Card number matches': 'Kaartnummer komt overeen',
    'Date matches': 'Datum komt overeen',
};
